"use strict";

exports.__esModule = true;
exports.mtcDefinition = void 0;
var mtcDefinition = exports.mtcDefinition = function mtcDefinition(translate) {
  return {
    columns: [{
      id: "timestamp",
      name: translate("DataTable.Column.Title.Timestamp", "Timestamp"),
      type: "date",
      dateFormat: "ShortDateTime",
      usePlantTime: true,
      canSearch: true,
      showSearchFilter: true,
      enableSorting: true,
      defaultSortOrder: "DESC"
    }, {
      id: "data_item_type",
      name: translate("DataTable.Column.Title.DataItemType", "Data Item Type"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true,
      enableSorting: true
    }, {
      id: "data_item_name",
      name: translate("DataTable.Column.Title.DataItemName", "Data Item Name"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true,
      enableSorting: true
    }, {
      id: "sub_type",
      name: translate("DataTable.Column.Title.SubType", "Sub Type"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true,
      enableSorting: true
    }, {
      id: "category",
      name: translate("DataTable.Column.Title.Category", "Category"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true,
      enableSorting: true
    }, {
      id: "value",
      name: translate("DataTable.Column.Title.Value", "Value"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }],
    parseData: function parseData(responseData) {
      var value = null;
      var isDefined = function isDefined(val) {
        return val !== undefined;
      };
      if (isDefined(responseData.value_event)) {
        value = responseData.value_event;
      } else if (isDefined(responseData.value_sample)) {
        value = responseData.value_sample;
      } else if (isDefined(responseData.value_path_position)) {
        var _responseData$value_p = responseData.value_path_position,
          _responseData$value_p2 = _responseData$value_p.x,
          x = _responseData$value_p2 === void 0 ? "" : _responseData$value_p2,
          _responseData$value_p3 = _responseData$value_p.y,
          y = _responseData$value_p3 === void 0 ? "" : _responseData$value_p3,
          _responseData$value_p4 = _responseData$value_p.z,
          z = _responseData$value_p4 === void 0 ? "" : _responseData$value_p4;
        value = x + "-" + y + "-" + z;
      }
      return Object.assign({}, responseData, {
        value: value
      });
    },
    // This is merged with the above definition so override anything configurable to produce a default configuration here
    createDefault: function createDefault() {
      return {
        enablePagination: true,
        overFetchAll: false,
        defaultPageSize: "auto",
        enableFetchOnSort: true,
        sort: [{
          property: "timestamp",
          direction: "desc"
        }],
        columns: [{
          id: "timestamp",
          name: translate("DataTable.Column.Title.Timestamp", "Timestamp"),
          type: "date",
          dateFormat: "ShortDateTime",
          usePlantTime: true,
          canSearch: true,
          enableSorting: true,
          showSearchFilter: true,
          defaultSortOrder: "DESC"
        }, {
          id: "data_item_type",
          name: translate("DataTable.Column.Title.DataItemType", "Data Item Type"),
          type: "string",
          canSearch: true,
          canFilter: true,
          enableSorting: true,
          showSearchFilter: true
        }, {
          id: "data_item_name",
          name: translate("DataTable.Column.Title.DataItemName", "Data Item Name"),
          type: "string",
          canSearch: true,
          canFilter: true,
          enableSorting: true,
          showSearchFilter: true
        }, {
          id: "value",
          name: translate("DataTable.Column.Title.Value", "Value"),
          type: "string",
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }]
      };
    }
  };
};